<cft-content-section
  [sectionId]="offeringsSection.id"
  [title]="offeringsSection.title"
  [plot]="offeringsSection.plot"
  [titleAlignment]="titleAlignment"
>
  <div class="hidden gap-md sm:grid md:grid-cols-2 xl:grid-cols-3">
    @for (item of offeringsSection.items; track item) {
      <cft-horizontal-list-card
        [icon]="item.icon"
        [title]="item.title"
        [description]="item.description"
        [routerLink]="item.targetPath"
        [queryParams]="targetQueryParams"
      >
      </cft-horizontal-list-card>
    }
  </div>

  <div class="block sm:hidden" #container *transloco="let t">
    <cft-slider [alignCenter]="false" [backButtonTitle]="t('slider.back')" [forwardButtonTitle]="t('slider.forward')">
      @for (col of columns; track col) {
        <div class="space-y-md" [style.width.px]="container.offsetWidth - 16">
          @for (item of col; track item) {
            <cft-horizontal-list-card
              class="block"
              [icon]="item.icon"
              [title]="item.title"
              [description]="item.description"
              [routerLink]="item.targetPath"
              [queryParams]="targetQueryParams"
            >
            </cft-horizontal-list-card>
          }
        </div>
      }
    </cft-slider>
  </div>

  @if (showOtherJobRequestSection) {
    <div class="mt-xl text-md">
      <ng-container *transloco="let t">
        <p>{{ t('offeringSection.jobNotFoundSection.notFound') }}</p>
        <p class="font-bold">{{ t('offeringSection.jobNotFoundSection.itsOk') }}</p>
        <button class="mt-md btn btn-primary btn-elevated" (click)="navigate(otherJobRequestPath)">
          {{ t('offeringSection.jobNotFoundSection.start') }}
        </button>
      </ng-container>
    </div>
  }
</cft-content-section>
